export default "__VITE_ASSET__BAIvZ_1M__"